import { render, staticRenderFns } from "./JustificationChips.vue?vue&type=template&id=0a290ae5"
import script from "./JustificationChips.vue?vue&type=script&lang=js"
export * from "./JustificationChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports